<template>
  <div class="rt-search">
    <el-input v-model="text" v-bind="$attrs" :placeholder="placeholder">
      <rt-icon slot="suffix" name="rt-base-lookup" @click="onSearch" />
    </el-input>

    <div v-if="more" class="rt-search-more" @click="onMore">
      <span class="rt-search-more-text">更多筛选</span>
      <rt-icon
        :class="iconDirector"
        :name="state.showMore ? 'rt-base-arrow_up' : 'rt-base-arrow_down'"
        size="10"
      />
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { store } from '../table/store';
export default {
  name: 'RtSearch',
  props: {
    value: [String, Number],
    placeholder: {
      type: String,
      default: '搜索'
    },
    more: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      text: this.value,
      state: store.state
    };
  },
  computed: {
    iconDirector() {
      return {
        'has-more': !!this.state.showMore
      };
    }
  },
  watch: {
    text(newVal) {
      this.$emit('input', newVal);
    },
    value(newVal) {
      this.text = newVal;
    }
  },
  methods: {
    onSearch() {
      this.$emit('on-search');
    },
    onMore() {
      store.TOGGLE_SHOW_MORE(!this.state.showMore);
    }
  }
};
</script>

<style lang="less">
.rt-search {
  display: flex;
  align-items: center;
  /* color: #DBE0F3; */
  .rt-search-more {
    display: flex;
    align-items: center;
    margin-left: 10px;
    color: #0099ff;
    font-size: 14px;
    position: relative;
    cursor: pointer;
    white-space: nowrap;
    span.rt-search-more-text {
      margin-right: 6px;
    }
    .has-more {
      padding: 0;
      display: flex;
      align-items: center;
      line-height: 1;
    }
    & > .rt-icon {
      padding: 0;
      line-height: 0;
    }
  }
  .rt-icon {
    padding: 8px 0;
  }
  .el-input__inner {
    height: 30px;
    line-height: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// rtSearch.vue?e0b243c4